import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import EntryComponent from '../../../Components/ContactListWrapper/EntryComponent';
import {
  CAMPAIGN_ACCORDION_STYLES as styles,
  CAMPAIGN_COLUMNS,
} from '../Utils/constants';
import MassiveMessageEntry from './OldMassiveMessageEntry';

//old sends have few fields: compact cards side by side instead of full width rows
const detailsSx = {
  ...styles.details,
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
};

const CampaignAccordion = function CampaignAccordion({
  data = {},
  template = '',
  handleDeleteMassiveSMS = () => {},
  handleOpenMassiveDetails = () => {},
  handleChangeAccordion = () => {},
  expanded = null,
}) {
  const { id, scheduledOn, massiveSmses = [] } = data;

  return (
    <Accordion
      id={`${id}-accordion`}
      expanded={expanded === id}
      onChange={handleChangeAccordion(id)}
      disableGutters
      elevation={0}
      sx={styles.root}
      slotProps={{ transition: { unmountOnExit: true } }}
    >
      <AccordionSummary sx={styles.summary} expandIcon={<ExpandMoreIcon />}>
        <EntryComponent
          data={{ ...data, templateName: template }}
          columns={CAMPAIGN_COLUMNS}
          disableClickRow
          hideDivider
          rowSxCallback={() => styles.summaryRow}
          statusSize="auto"
          customStatusChipCallback={() => null}
        />
      </AccordionSummary>
      <AccordionDetails sx={detailsSx}>
        {massiveSmses.map((massive) => (
          <Paper
            key={massive?.massiveId}
            variant="outlined"
            sx={styles.sendPaper}
          >
            <MassiveMessageEntry
              scheduledOn={scheduledOn}
              messageData={massive}
              campaignId={id}
              handleDeleteMassiveSMS={handleDeleteMassiveSMS}
              handleOpenMassiveDetails={handleOpenMassiveDetails}
            />
          </Paper>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default CampaignAccordion;
